import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { NvDesignLibraryModule } from 'Src/nvps-libraries/design/nv-design-library.module';
import { BaseModalModule } from '../../base-modal.module';
import { ActivityStatusModalComponent } from './activity-status-modal.component';

@NgModule({
  declarations: [ActivityStatusModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    MatOptionModule,
    FormsModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    BaseModalModule,
    MatMenuModule,
    NvDesignLibraryModule,
  ],
  exports: [ActivityStatusModalComponent],
  providers: [],
  entryComponents: [ActivityStatusModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ActivityStatusModalModule {}
